import { type ReactNode } from 'react'
import { cn } from '../../lib/utils'

interface FullPageOverlayProps {
  children: ReactNode;
  onClose?: () => void;
  variant?: 'light' | 'dark';
  className?: string;
}

export const FullPageOverlay = ({
  children,
  onClose,
  variant = 'light',
  className,
}: FullPageOverlayProps) => {
  return (
    <div
      className={cn(
        "fixed inset-0 z-50 flex items-center justify-center p-4",
        variant === 'dark' ? 'bg-black/60 backdrop-blur-sm' : 'bg-white/95',
        className,
      )}
      onClick={onClose}
    >
      <div onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  )
}
